/* eslint-disable @typescript-eslint/max-params */
/* eslint-disable unicorn/no-keyword-prefix */
import type { SizeProp } from '@fortawesome/fontawesome-svg-core'
import type { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const HSIcon =
	(
		properties: IconDefinition,
		classNames = '',
		size: SizeProp = 'sm',
		onClick?: () => void
	) =>
	() => (
		<FontAwesomeIcon
			icon={properties}
			size={size}
			onClick={onClick}
			className={classNames}
		/>
	)

export default HSIcon
